// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantBoard-moduleRentalPortalApplicantBoard__mAGnU";
var _2 = "RentalPortalApplicantBoard-modulecolumns__ohGO0";
export { _1 as "RentalPortalApplicantBoard", _2 as "columns" }
